module.exports = __webpack_public_path__ + "static/media/297504.48c7075e.png";